import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { FileService } from '@services/wiki/file.service';
import { SearchedService } from '@services/wiki/searched.service';
import { EditorService } from '@services/wiki/editor.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { UtilitiyService } from '@services/wiki/utility.service';
import { AuthService } from '@services/auth.service';
import { TextToFind } from '@classes/wiki/text-to-find.model';
import { environment } from '@environments/environment';
import FileSaver from 'file-saver';
import { Subscription } from 'rxjs/internal/Subscription';
import { LicenceRoleType } from '@enums/licence-role-type.enum';
import { ProviderType } from '@enums/provider-type.enum';

@Component({
  selector: 'app-wiki',
  templateUrl: './wiki.component.html',
  styleUrls: ['./wiki.component.scss']
})
export class WikiComponent implements OnInit, OnDestroy {

  private editModeSub: Subscription;
  private fileSelectedSub: Subscription;
  private editorSub: Subscription;


  findTextForm: FormGroup;
  hasSelectedAFile: boolean;
  checked: boolean;
  languages: string[];
  selectedLanguage = 'fr';
  isInEditMode = false;
  titleBool = true;
  contentBool = true;
  isBizzDev = false;
  providerType = ProviderType;
  selectedDirectoryOrFilePath: string;
  selectedDirectoryOrFileName: string;

  selectedProviderType: ProviderType;

  constructor(
    private fileService: FileService,
    private searchedService: SearchedService,
    private editorService: EditorService,
    private fb: FormBuilder,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private utilityService: UtilitiyService,
    private authService: AuthService) {
   }

   ngOnInit() {
    this.initPage();
  }

  onSubmit(): void {
    const lg = 'fr'; // this.authService.getDecodedToken().language;
    if (this.findTextForm.value.textToFind && (this.titleBool || this.contentBool)) {
      if (this.titleBool && this.contentBool) {
        this.searchForWord(new TextToFind(this.findTextForm.value.textToFind, lg, 'contentAndTitle'));
      } else {
        this.searchForWord(new TextToFind(this.findTextForm.value.textToFind, lg, this.titleBool ? 'title' : 'content'));
      }
      this.router.navigate(['/wiki/search']);
    }
  }

  goToReorder(): void {
    this.router.navigate(['/wiki/reorder']);
  }

  changeEditMode(event): void {
    this.editorService.changeEditMode(event.checked);
    sessionStorage.setItem(environment.editable, event.checked.toString());
  }

  changeSearchTitle(): void {
    this.contentBool = true;
  }

  changeSearchContent(): void {
    this.titleBool = true;
  }

  printToPdf(): void {
    this.editorService.printFile(this.selectedDirectoryOrFilePath, this.selectedProviderType).subscribe(data => {
      const fileName = `${this.utilityService.stripHtml(this.selectedDirectoryOrFileName)}.pdf`;
      const blob = new Blob([data], {type: 'application/pdf'});
      FileSaver.saveAs(blob, fileName);
    });
  }

  providerChange(): void {
    sessionStorage.setItem(environment.provider, this.selectedProviderType);
    this.fileService.changeProviderSub(this.selectedProviderType);
    this.router.navigate(['/wiki']);
  }

  private initPage() {
    const token = this.authService.getDecodedToken();
    if (token.role === LicenceRoleType.bzd || token.role === LicenceRoleType.bko) {
      this.isBizzDev = true;
    }
    const pv = sessionStorage.getItem(environment.provider);
    this.selectedProviderType = (pv !== null && pv !== undefined && pv !== '') ? pv as ProviderType : token.provider_category;
    // this.isBizzDev = true;
    this.selectedLanguage = token.language;

    this.editModeSub = this.editorService.getEditMode().subscribe(mode => {
      if (this.isBizzDev) {
        this.isInEditMode = mode;
      }
    });

    this.findTextForm = this.fb.group({
      textToFind: ['']
    });

    const isInEditMode = sessionStorage.getItem(environment.editable);
    if (isInEditMode && isInEditMode === 'true') {
      this.isInEditMode = true;
    }

    this.fileSelectedSub = this.fileService.getHasSelectedAFile().subscribe(data => {
      this.hasSelectedAFile = data;
    });

    this.editorSub = this.fileService.getEditorSub().subscribe(dm => {
      this.selectedDirectoryOrFilePath = dm.path;
      this.selectedDirectoryOrFileName = dm.name;
      this.cdr.detectChanges();
    });
  }

  private searchForWord(ttf: TextToFind): void {
    this.searchedService.changeTextToFindSub(ttf);
    sessionStorage.setItem(environment.wordSearched, JSON.stringify(ttf));
  }

  ngOnDestroy(): void {
    if (this.editorSub) {
      this.editorSub.unsubscribe();
    }
    if (this.editModeSub) {
      this.editModeSub.unsubscribe();
    }
    if (this.fileSelectedSub) {
      this.fileSelectedSub.unsubscribe();
    }
  }
}
